'use client'
import React from "react";
import cl from 'clsx'
import 'keen-slider/keen-slider.min.css'
import { useKeenSlider } from 'keen-slider/react'
import Title from '@/ui/title';
import Button from '@/ui/button';
import Image from 'next/image';
import image from '@/public/images/looks-image.png'
import image_1 from '@/public/images/Homepage_tablet_1.png'
import image_2 from '@/public/images/Homepage_tablet_2.png'
import image_3 from '@/public/images/Homepage_tablet_3.png'
import image_4 from '@/public/images/Homepage_tablet_4.png'
import image_5 from '@/public/images/Homepage_tablet_6.png'
import { ScrollPanel } from "primereact/scrollpanel";
import styles from './styles.module.css'
import './styles.css'

export default function Looks({dict}) {
    const {
        section_title,
        first_line,
        second_line,
        description_1,
        description_2,
        list_1_item_1,
        list_1_item_2,
        description_3,
        list_2_item_1,
        list_2_item_2
    } = dict.looks;
    const [sliderRef, instanceRef] = useKeenSlider(
    {
        slidesPerView: 1,
        mode: 'snap',
        loop: true,
    })

    const prevSlide = () => {
        if (instanceRef) instanceRef.current?.prev();
    };

    const nextSlide = () => {
        if (instanceRef) instanceRef.current?.next();
    };

    return (
        <section className={styles.looks}>
            <div className={cl(styles.looks__wrapper, "container")}>
                <div className={styles.looks__content}>
                    <Title
                        title={section_title}
                        firstLine={first_line}
                        secondLine={second_line}
                        section="looks"
                    />
                    <ScrollPanel style={{width: '100%', height: '200px'}} className="custombar2">
                        <div className={styles.looks__text_block}>
                            <p className={styles.looks__description}>{description_1}</p>
                            <p className={styles.looks__description}>{description_2}</p>
                            <ol className={styles.looks__description_list}>
                                <li>{list_1_item_1}</li>
                                <li>{list_1_item_2}</li>
                            </ol>
                            <p className={styles.looks__description}>{description_3}</p>
                            <ol className={styles.looks__description_list}>
                                <li>{list_2_item_1}</li>
                                <li>{list_2_item_2}</li>
                            </ol>
                        </div>
                    </ScrollPanel>
                    <div className={styles.looks__button_wrapper}>
                        <Button onClick={prevSlide} type='round-left-grey'/>
                        <Button onClick={nextSlide} type='round-right-grey'/>
                    </div>
                </div>
                <div ref={sliderRef} className={cl(styles.looks__image_wrapper, 'keen-slider')}>
                    <Image className='keen-slider__slide' src={image_1} width={765} height={570} alt='image'/>
                    <Image className='keen-slider__slide' src={image_2} width={765} height={570} alt='image'/>
                    <Image className='keen-slider__slide' src={image_3} width={765} height={570} alt='image' />
                    <Image className='keen-slider__slide' src={image_4} width={765} height={570} alt='image' />
                    <Image className='keen-slider__slide' src={image_5} width={765} height={570} alt='image' />
                </div>
                <div className={styles.looks__image_buttons}>
                    <Button onClick={prevSlide} type='round-left-grey' />
                    <Button onClick={nextSlide} type='round-right-grey' />
                </div>
            </div>
        </section>
    );
}